export default "__VITE_ASSET__63d8f8c7__"